import {config} from 'config/env';
import {createUserAddressV2, getUserAddressesV2, updateUserAddressV2} from 'services/location/location-address-service';
import {createUserAddressV1, getUserAddressesV1, updateUserAddressV1} from 'services/user/user-service';
import {
  AddressTypeEnum,
  CreateAddressInputType,
  IDefaultUserAddressesResponse,
  UpdateAddressInputType,
  UserAddress
} from 'types';
import {convertUserAddressV2ToUserAddress} from 'utils';

export const getUserAddresses = async (accessToken: string, addressType?: AddressTypeEnum): Promise<UserAddress[]> => {
  if (config.ENABLE_LOCATION_SERVICE_ADDRESSES) {
    const result = await getUserAddressesV2(accessToken, addressType);
    return result.map(convertUserAddressV2ToUserAddress);
  }
  const result = (await getUserAddressesV1(accessToken, addressType)) as {
    data: IDefaultUserAddressesResponse;
  };
  return result.data?.getUserAddresses;
};

export const updateUserAddress = async (
  accessToken: string,
  addressId: string,
  updateAddressInput: UpdateAddressInputType,
  addressType?: AddressTypeEnum
): Promise<UserAddress> => {
  if (config.ENABLE_LOCATION_SERVICE_ADDRESSES) {
    const result = await updateUserAddressV2(accessToken, addressId, {...updateAddressInput, addressType});
    return convertUserAddressV2ToUserAddress(result);
  }
  const result = await updateUserAddressV1(accessToken, addressId, updateAddressInput, addressType);
  return result.data?.updateUserAddress;
};

export const createUserAddress = async (
  accessToken: string,
  createAddressInput: CreateAddressInputType
): Promise<UserAddress> => {
  if (config.ENABLE_LOCATION_SERVICE_ADDRESSES) {
    const result = await createUserAddressV2(accessToken, createAddressInput);
    return convertUserAddressV2ToUserAddress(result);
  }
  const result = await createUserAddressV1(accessToken, createAddressInput);
  return result.data?.createUserAddress;
};
